import {createAxiosInstance} from './base.api'

const taskResourceApi = 'taskResources'

export const getTaskResource = (id, errorMethod) => createAxiosInstance(taskResourceApi).get(`/${id}`)
.catch(error => errorMethod(error))

export const updateTaskResource = (id, taskResource, successMethod, errorMethod) => createAxiosInstance(taskResourceApi).put(`/${id}`, taskResource)
.then(response => successMethod(response))
.catch(error => errorMethod(error))